import { render, staticRenderFns } from "./TermListTable.vue?vue&type=template&id=081f34e2&"
import script from "./TermListTable.vue?vue&type=script&lang=js&"
export * from "./TermListTable.vue?vue&type=script&lang=js&"
import style0 from "./TermListTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports